import { audio } from '@/audio-singleton';
import { useEffect, useRef } from 'preact/hooks';
import { acquireScrollLock, releaseScrollLock } from './scroll-lock';
import { pushEscape } from './escape-stack';

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  body: string;
  cancelLabel: string;
  confirmLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmDialog({ open, title, body, cancelLabel, confirmLabel, onCancel, onConfirm }: ConfirmDialogProps) {
  const cardRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!open) return;
    acquireScrollLock();
    const popEsc = pushEscape(onCancel);
    cardRef.current?.querySelector<HTMLButtonElement>('button')?.focus();
    return () => {
      popEsc();
      releaseScrollLock();
    };
  }, [open, onCancel]);

  if (!open) return null;
  return (
    <div class="fixed inset-0 z-50 pointer-events-auto flex items-center justify-center px-6">
      <div class="absolute inset-0 bg-black/60" onClick={onCancel} aria-hidden="true" />
      <div
        ref={cardRef}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-title"
        class="relative bg-white text-[#222] rounded-2xl p-6 max-w-sm w-full shadow-2xl"
      >
        <h2 id="confirm-title" class="text-lg font-bold mb-2">{title}</h2>
        <p class="text-sm mb-5">{body}</p>
        <div class="flex gap-3 justify-end">
          <button class="px-4 py-2 rounded-lg bg-gray-200" onClick={() => { audio().play('tap'); onCancel(); }}>{cancelLabel}</button>
          <button class="px-4 py-2 rounded-lg bg-red-500 text-white" onClick={() => { audio().play('tap'); onConfirm(); }}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
